
export var jquery = require('jquery');
export var mediatorjs = require('mediatorjs');
export var Cookies = require('js-cookie');
window.Cookies = Cookies;



// WEBPACK FOOTER //
// ./uikit/utilities/vendor.js